import { FC } from 'react';

import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import liff from '@line/liff';

import { usePageTitle } from 'hooks/usePageTitle';

import { CopyButton } from 'components/features/CopyButton/CopyButton';
import { Button } from 'components/parts/Button';
import { ButtonLink } from 'components/parts/ButtonLink';
import { Paragraph } from 'components/parts/Paragraph';
import { RootState } from 'store';

import styles from './Info.module.scss';
export const Info: FC = () => {
  const navigate = useNavigate();

  // LINE ユーザIDをstoreへ保存
  const decodeIdToken = liff.getDecodedIDToken();

  usePageTitle(`システム情報`);

  const browsingCondition = [
    {
      label: 'USER ID:',
      value: decodeIdToken?.sub || '',
    },
    {
      label: 'OS:',
      value: liff.getOS() || '',
    },
    {
      label: 'LINE:',
      value:
        liff.getLineVersion() !== null
          ? `ver.${liff.getLineVersion()}`
          : 'ブラウザからの表示' || '',
    },
    {
      label: 'userAgent:',
      value: window.navigator.userAgent || '',
    },
  ];
  const { systemSupport } = useSelector((state: RootState) => state.external);

  // サポート情報のテキストを生成
  const supportInfoText = browsingCondition.map(item => `${item.label} ${item.value}`).join('\n');

  const fullSupportText = `システム情報\n${supportInfoText}`;

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.body}>
          <Paragraph>
            サポートが必要な場合、サポート情報をコピーしてお問い合わせください。
          </Paragraph>
          <div className={styles.list}>
            <dl className={styles.listInner}>
              {browsingCondition.map(item => (
                <div className={styles.item} key={item.label}>
                  <dt className={styles.label}>{item.label}</dt>
                  <dd className={styles.value}>{item.value}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
        <div className={styles.foot}>
          <div className={styles.footCopy}>
            <CopyButton
              text={fullSupportText}
              buttonText="サポート情報をコピー"
              successMessage={
                <>
                  <Paragraph>サポート情報をコピーしました。</Paragraph>
                  <Paragraph>フォームを開き、内容の詳細にペーストしてください。</Paragraph>
                  <div className={styles.dialogFooter}>
                    <ButtonLink
                      text="システムサポートへ"
                      styleType="secondary"
                      href={systemSupport}
                      target="_blank"
                      rel="noreferrer"
                    />
                  </div>
                </>
              }
              styleType="secondary"
            />
          </div>
          <div className={styles.footContact}>
            <ButtonLink
              text="システムサポートへ"
              styleType="primary"
              href={systemSupport}
              target="_blank"
              rel="noreferrer"
            />
          </div>
          <div className={styles.footBack}>
            <Button text="メニューに戻る" styleType="text" handleClick={() => navigate('/menu')} />
          </div>
        </div>
      </div>
    </div>
  );
};
